// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3dd6b200","232":"335b92f0","237":"4ad92e49","526":"6d641fc1","787":"1ed0c42c","872":"9102b29a"}[chunkId] + ".chunk.js";
};